<app-sidebar>
  <div style="height: 100%; width: 100%; position: relative">
    <router-outlet></router-outlet>
  </div>
</app-sidebar>
